"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const SVGComponent = (props) => (React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", Object.assign({ fill: "none" }, props),
        React.createElement("path", { d: "M8.00065 15.9167C3.63398 15.9167 0.0839844 12.3667 0.0839844 8.00004C0.0839844 3.63337 3.63398 0.083374 8.00065 0.083374C12.3673 0.083374 15.9173 3.63337 15.9173 8.00004C15.9173 12.3667 12.3673 15.9167 8.00065 15.9167ZM8.00065 1.33337C4.32565 1.33337 1.33398 4.32504 1.33398 8.00004C1.33398 11.675 4.32565 14.6667 8.00065 14.6667C11.6757 14.6667 14.6673 11.675 14.6673 8.00004C14.6673 4.32504 11.6757 1.33337 8.00065 1.33337Z" }),
        React.createElement("path", { d: "M12.0418 5.2002C11.7168 5.39186 11.3501 5.53353 10.9585 5.61686C10.6501 5.28353 10.2085 5.0752 9.7168 5.0752C8.77513 5.0752 8.0168 5.83353 8.0168 6.7752C8.0168 6.90853 8.03346 7.04186 8.05846 7.16686C6.6418 7.09186 5.3918 6.41686 4.55013 5.39186C4.40013 5.64186 4.3168 5.93353 4.3168 6.2502C4.3168 6.84186 4.6168 7.35853 5.07513 7.66686C4.80013 7.65853 4.53346 7.58353 4.30013 7.4502V7.4752C4.30013 8.3002 4.88346 8.98353 5.6668 9.14186C5.52513 9.18353 5.37513 9.20019 5.2168 9.20019C5.10846 9.20019 5.00013 9.19186 4.90013 9.16686C5.1168 9.84186 5.7418 10.3335 6.4918 10.3502C5.90846 10.8085 5.17513 11.0752 4.37513 11.0752C4.2418 11.0752 4.10013 11.0752 3.9668 11.0502C4.7168 11.5335 5.6168 11.8169 6.57513 11.8169C9.70846 11.8169 11.4168 9.2252 11.4168 6.9752C11.4168 6.9002 11.4168 6.8252 11.4168 6.75853C11.7501 6.51686 12.0418 6.21686 12.2668 5.8752C11.9585 6.00853 11.6335 6.1002 11.2918 6.14186C11.6418 5.93353 11.9168 5.6002 12.0418 5.2002Z" }))));
exports.default = SVGComponent;
//# sourceMappingURL=twitter.js.map